import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import DrList from './DrList'

const DrListWrapper = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>Doctor List</PageTitle>
            <DrList />
        </>
    )
}

export default DrListWrapper